import { createSelector } from 'reselect'
import { compareAsc, isSameMonth } from 'date-fns'
import { get } from 'lodash'
import { IStore } from '../index'
import {
  getEvents,
  notInRemovedAndRemovedRooms,
  withoutCancelled,
} from '../bookingCalendar/selectors/events'
import { EventStatus } from '../../models/Event'
import { ReservationSortOrder } from './index'

export const getReservationsListDate = (state: IStore) =>
  state.reservationsList.date
export const getReservationsListSortOrder = (state: IStore) =>
  state.reservationsList.sortOrder
export const getReservationsListCanceledEvents = createSelector(
  [notInRemovedAndRemovedRooms, getReservationsListDate],
  (events, date) =>
    events.filter(
      e => isSameMonth(e.createdAt, date) && e.stage === EventStatus.Canceled,
    ),
)
export const getReservationsListNewEvents = createSelector(
  [withoutCancelled, getReservationsListDate],
  (events, date) => events.filter(e => isSameMonth(e.createdAt, date)),
)

export const getReservationsListDeletedEvents = createSelector(
  [getEvents, getReservationsListDate],
  (events, date) =>
    events.filter(e => isSameMonth(e.createdAt, date) && e.isDeleted),
)
export const getReservationsListCanceled = (state: IStore) =>
  state.reservationsList.canceledReservations
export const getReservationsListDeleted = (state: IStore) =>
  state.reservationsList.deletedReservations
export const getReservationsListNew = (state: IStore) =>
  state.reservationsList.newReservations
export const getReservationsListLoading = (state: IStore) =>
  state.reservationsList.loading
export const getReservationsListSearch = (state: IStore) =>
  state.reservationsList.search

export const getReservationsListNewFiltered = createSelector(
  [getReservationsListNew, getReservationsListSearch],
  (events, filter) =>
    filter.length >= 3
      ? events.filter(c =>
          ['guest.name', 'guest.phone', 'guest.email', 'id', 'bookingId']
            .map(path => get(c, path, ''))
            .some(v =>
              v
                .toString()
                .toLocaleLowerCase()
                .includes(filter.toLocaleLowerCase()),
            ),
        )
      : events,
)

export const getReservationsListCanceledFiltered = createSelector(
  [getReservationsListCanceled, getReservationsListSearch],
  (events, filter) => {
    return filter.length >= 3
      ? events.filter(c =>
          ['guest.name', 'guest.phone', 'guest.email', 'id', 'bookingId']
            .map(path => get(c, path, ''))
            .some(v =>
              v
                .toString()
                .toLocaleLowerCase()
                .includes(filter.toLocaleLowerCase()),
            ),
        )
      : events
  },
)

export const getReservationsListDeletedFiltered = createSelector(
  [getReservationsListDeleted, getReservationsListSearch],
  (events, filter) => {
    return filter.length >= 3
      ? events.filter(c =>
          ['guest.name', 'guest.phone', 'guest.email', 'id', 'bookingId']
            .map(path => get(c, path, ''))
            .some(v =>
              v
                .toString()
                .toLocaleLowerCase()
                .includes(filter.toLocaleLowerCase()),
            ),
        )
      : events
  },
)

export const getReservationsListCanceledSorted = createSelector(
  [getReservationsListCanceledFiltered, getReservationsListSortOrder],
  (events, sortOrder) => {
    switch (sortOrder) {
      case ReservationSortOrder.AddDate:
        return [...events.sort((a, b) => compareAsc(b.createdAt, a.createdAt))]
      case ReservationSortOrder.StartDate:
        return [...events.sort((a, b) => compareAsc(b.startDate, a.startDate))]
    }
  },
)

export const getReservationsListDeletedSorted = createSelector(
  [getReservationsListDeletedFiltered, getReservationsListSortOrder],
  (events, sortOrder) => {
    switch (sortOrder) {
      case ReservationSortOrder.AddDate:
        return [...events.sort((a, b) => compareAsc(b.createdAt, a.createdAt))]
      case ReservationSortOrder.StartDate:
        return [...events.sort((a, b) => compareAsc(b.startDate, a.startDate))]
    }
  },
)

export const getReservationsListNewSorted = createSelector(
  [getReservationsListNewFiltered, getReservationsListSortOrder],
  (events, sortOrder) => {
    switch (sortOrder) {
      case ReservationSortOrder.AddDate:
        return [...events.sort((a, b) => compareAsc(b.createdAt, a.createdAt))]
      case ReservationSortOrder.StartDate:
        return [...events.sort((a, b) => compareAsc(b.startDate, a.startDate))]
    }
  },
)
